import arrayBuffer2BinStr from './arrayBuffer2BinStr';
import base64ToArrayBuffer from './base64ToArrayBuffer';
import arrayBufferToBase64 from './arrayBufferToBase64';

/**
 * rsa加密
 * @param data 要加密的数据
 * @param publicKey rsa公钥
 * @returns 加密后的base64字符串
 */
export async function encrypt(data: string | ArrayBuffer, publicKey: string) {
  // 将base64的公钥转成 buffer
  const keyBuffer = base64ToArrayBuffer(publicKey);
  const key = await crypto.subtle.importKey(
    'spki',
    keyBuffer,
    {
      name: 'RSA-OAEP',
      hash: 'SHA-1',
    },
    false,
    ['encrypt']
  );
  // 将要加密的字符串转成 buffer
  if (typeof data === 'string') {
    data = new TextEncoder().encode(data);
  }
  const encryptedDataBuffer = await crypto.subtle
    .encrypt(
      {
        name: 'RSA-OAEP',
      },
      key,
      data
    )
    .catch(() => null);

  if (!encryptedDataBuffer) {
    return false;
  }

  return arrayBufferToBase64(encryptedDataBuffer);
}

/**
 * rsa解密
 * @param data 要解密的base64字符串
 * @param privateKey 私钥
 * @returns 解密后的原始字符串
 */
export async function decrypt(data: string, privateKey: string) {
  // 将base64的私钥转成 buffer
  const keyBuffer = base64ToArrayBuffer(privateKey);
  const key = await crypto.subtle.importKey(
    'pkcs8',
    keyBuffer,
    {
      name: 'RSA-OAEP',
      hash: 'SHA-1',
    },
    false,
    ['decrypt']
  );
  // 将base64的加密字符串数据转成 buffer
  const dataBuffer = base64ToArrayBuffer(data);
  const decryptedDataBuffer = await crypto.subtle
    .decrypt(
      {
        name: 'RSA-OAEP',
      },
      key,
      dataBuffer
    )
    .catch(() => null);

  if (!decryptedDataBuffer) {
    return false;
  }

  return arrayBuffer2BinStr(decryptedDataBuffer);
}

export default {
  encrypt,
  decrypt,
};
